import styled from 'styled-components';
import { useEffect, useState } from 'react';

import { bugsnag } from 'shared/utils/services/bugsnag';
import { DEFAULT_ASSET_WIDTH_BEFORE_UI_RENDERS } from 'homepage/enums/contentConstants';
import {
  DESKTOP_PADDING,
  MOBILE_PADDING,
  TOTAL_DESKTOP_PADDING,
  TOTAL_MOBILE_PADDING,
} from 'homepage/styles/constants';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { Space } from 'shared/components/Space';
import { ISpaceArticleSection } from 'shared/types/SpaceArticleSection';

export const SpaceArticleSection = (section: ISpaceArticleSection) => {
  const { id, uuid } = section || {};
  const { isMobile, windowSize } = useWindowSize();

  const [canvasWidth, setCanvasWidth] = useState(DEFAULT_ASSET_WIDTH_BEFORE_UI_RENDERS);

  useEffect(() => {
    try {
      const spaceContainer: HTMLElement = document.querySelector(`#space-section-${uuid || id}`);
      if (spaceContainer) {
        setCanvasWidth(windowSize?.width);
      }
    } catch (error) {
      bugsnag(error, { context: 'No space container element for space' });
    }
  }, [id, isMobile, windowSize]);

  const currentPadding = isMobile ? TOTAL_MOBILE_PADDING : TOTAL_DESKTOP_PADDING;

  return (
    <SpaceArticleSection.Container id={`space-section-${uuid || id}`}>
      <Space section={section} maxWidth={canvasWidth - currentPadding} />
    </SpaceArticleSection.Container>
  );
};

SpaceArticleSection.Container = styled.div`
  width: 100%;
  margin: 32px 0px;
  padding: 0px ${MOBILE_PADDING};
  z-index: ${({ theme }) => theme.zIndex.homepageBrandContent};

  @media (min-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    margin: 60px 0px;
    padding: 0px ${DESKTOP_PADDING};
  }
`;
